/**
 * Converter Flavours
 *
 * An enumeration for Converter Flavours
 *
 * @author <a href="mailto:tor@zuehlke.com">Tobias Rudolphi</a>, Z&uuml;hlke Engineering GmbH, Eschborn, Germany
 *
 * Generated from Unit.xml
 */
var Flavours = {
    /**
     * @property {String} LEN
     * Code for flavour LEN
     */
    LEN : 'len',
    /**
     * @property {String} BUSHEL
     * Code for flavour BUSHEL
     */
    BUSHEL : 'bushel',
    /**
     * @property {String} PIECE
     * Code for flavour PIECE
     */
    PIECE : 'piece',
    /**
     * @property {String} PRESSURE
     * Code for flavour PRESSURE
     */
    PRESSURE : 'pressure',
    /**
     * @property {String} LIQUIDPERLEN
     * Code for flavour LIQUIDPERLEN
     */
    LIQUIDPERLEN : 'liquidPERlen',
    /**
     * @property {String} WARTUNGSMELDUNG
     * Code for flavour WARTUNGSMELDUNG
     */
    WARTUNGSMELDUNG : 'wartungsmeldung',
    /**
     * @property {String} LIQUIDPERAREAL
     * Code for flavour LIQUIDPERAREAL
     */
    LIQUIDPERAREAL : 'liquidPERareal',
    /**
     * @property {String} ACCELERATION
     * Code for flavour ACCELERATION
     */
    ACCELERATION : 'acceleration',
    /**
     * @property {String} PIECEPERAREAL
     * Code for flavour PIECEPERAREAL
     */
    PIECEPERAREAL : 'piecePERareal',
    /**
     * @property {String} TIME
     * Code for flavour TIME
     */
    TIME : 'time',
    /**
     * @property {String} POSITION
     * Code for flavour POSITION
     */
    POSITION : 'position',
    /**
     * @property {String} MASSPERAREAL
     * Code for flavour MASSPERAREAL
     */
    MASSPERAREAL : 'massPERareal',
    /**
     * @property {String} LIQUIDPERTIME
     * Code for flavour LIQUIDPERTIME
     */
    LIQUIDPERTIME : 'liquidPERtime',
    /**
     * @property {String} CURRENCY
     * Code for flavour CURRENCY
     */
    CURRENCY : 'currency',
    /**
     * @property {String} BOOLEAN
     * Code for flavour BOOLEAN
     */
    BOOLEAN : 'boolean',
    /**
     * @property {String} MASSPERTIME
     * Code for flavour MASSPERTIME
     */
    MASSPERTIME : 'massPERtime',
    /**
     * @property {String} LIQUID
     * Code for flavour LIQUID
     */
    LIQUID : 'liquid',
    /**
     * @property {String} MASS
     * Code for flavour MASS
     */
    MASS : 'mass',
    /**
     * @property {String} SPEED
     * Code for flavour SPEED
     */
    SPEED : 'speed',
    /**
     * @property {String} AREALPERTIME
     * Code for flavour AREALPERTIME
     */
    AREALPERTIME : 'arealPERtime',
    /**
     * @property {String} LIQUIDPERMASS
     * Code for flavour LIQUIDPERMASS
     */
    LIQUIDPERMASS : 'liquidPERmass',
    /**
     * @property {String} CONCENTRATION
     * Code for flavour CONCENTRATION
     */
    CONCENTRATION : 'concentration',
    /**
     * @property {String} DATATYP
     * Code for flavour DATATYP
     */
    DATATYP : 'datatyp',
    /**
     * @property {String} ELECTRICITY
     * Code for flavour ELECTRICITY
     */
    ELECTRICITY : 'electricity',
    /**
     * @property {String} DEFAULT
     * Code for flavour DEFAULT
     */
    DEFAULT : 'default',
    /**
     * @property {String} PERCENTAGE
     * Code for flavour PERCENTAGE
     */
    PERCENTAGE : 'percentage',
    /**
     * @property {String} VOLTAGE
     * Code for flavour VOLTAGE
     */
    VOLTAGE : 'voltage',
    /**
     * @property {String} TEMP
     * Code for flavour TEMP
     */
    TEMP : 'temp',
    /**
     * @property {String} AREAL
     * Code for flavour AREAL
     */
    AREAL : 'areal',
    /**
     * @property {String} ROUNDS
     * Code for flavour ROUNDS
     */
    ROUNDS : 'rounds'
};

global.Flavors = Flavours;